export default "__VITE_ASSET__MLeocBWs__"